import React from "react";

/**
 * Consistent error banner used across all UI workflows so users know where to look.
 * Place it in the same position on every page: right below the page title.
 */
const BANNER_STYLE = {
  padding: "12px 16px",
  marginBottom: "12px",
  backgroundColor: "#f8d7da",
  border: "1px solid #f5c2c7",
  borderRadius: "8px",
  color: "#842029",
  fontSize: "14px",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "12px",
};

const DISMISS_BTN_STYLE = {
  padding: "2px 8px",
  border: "none",
  background: "transparent",
  color: "#842029",
  cursor: "pointer",
  fontSize: "18px",
  lineHeight: 1,
  flexShrink: 0,
  opacity: 0.8,
};

function ErrorBanner({ message, onDismiss }) {
  if (!message) return null;
  return (
    <div style={BANNER_STYLE} role="alert">
      <span style={{ flex: 1 }}>{message}</span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          style={DISMISS_BTN_STYLE}
          aria-label="Dismiss"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default ErrorBanner;
